export default ({ content_type, type }) => (type || content_type).indexOf('image/') === 0;
